<template>
  <div>
    <button
      v-if="is_content_hidden"
      class="mb-2 btn btn-info text-white"
      @click="isActive = !isActive"
    >
      <slot>Breakdown</slot> [ {{ hide_or_show_text }} ]
    </button>
    <div v-if="isActive" class="breakdown-content">
      <single-price-breakdown :title="title" :breakdown="breakdown">
      </single-price-breakdown>
    </div>
  </div>
</template>
<style lang="scss">
.breakdown-content {
  border: 1px solid #eee;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.03);
  padding: 15px;
}
</style>
<script>
export default {
  data() {
    return {
      isActive: !this.is_content_hidden,
    };
  },
  props: ["title", "breakdown", "is_content_hidden"],
  created() {},
  mounted() {},
  computed: {
    hide_or_show_text() {
      return this.isActive ? "hide" : "show";
    },
  },
};
</script>
